
import { Link } from "react-router-dom";
import { FaSquareGithub,FaLinkedin,FaSquareFacebook } from  "react-icons/fa6";
import { SiGmail } from "react-icons/si";


function Header({showMenu,setShowMenu}) {
   
//     let menuRef = useRef(null);
//     let buttonRef = useRef(null);
//     const handle =(e)=>{
//         if(menuRef.current && !menuRef.current.contains(e.target)&&e.target !== buttonRef.current){
//             setShowMenu(false);
//         }
//     }

// useEffect(()=>{

// document.addEventListener("click",handle);
// return()=>{
//     document.addEventListener("click",handle)
// }

// },[])
    return(
        <header>
        <div>
        
        <h1><Link to="/">Yousif Ibrahim</Link></h1>
       
            <div className={`menu ${showMenu?`rotate`:``}`}  onClick={()=>setShowMenu(!showMenu)}>
            <div></div>
            <div></div>
            <div></div>
            </div>
        </div>
        <ul className={showMenu?`show-menu`:""}>
            <Link to="/" onClick={()=>setShowMenu(!showMenu)}><li>Home</li></Link>
            <Link to="/about" onClick={()=>setShowMenu(!showMenu)}><li>About</li></Link>
            <Link to="/projects" onClick={()=>setShowMenu(!showMenu)}><li>Projects</li></Link>
            <Link to="/contact" onClick={()=>setShowMenu(!showMenu)}><li>Contact</li></Link>
            {/* <li>About</li>
            <li>Projects</li>
            <li>Contact</li> */}
            <li id="socil">

        <Link to="www.linkedin.com/in/yousif-ibrahim-23b27b313" target="_blank" ><FaLinkedin/></Link>
        <Link to="https://www.facebook.com/share/tU2ntm7uAjnRZJxW/?mibextid=qi2Omg" target="_blank" ><FaSquareFacebook/></Link>
        <Link to="https://github.com/249joe" target="_blank" ><FaSquareGithub/></Link>
        <Link to="https://mail.google.com" target="_blank" ><SiGmail/></Link>
            </li>
        </ul>
        

       
        </header>
    )
}
export default Header;
